import { matchSorter } from 'match-sorter'
import dayjs from 'dayjs'

export const ENTRY_TYPES = {
  CROP: 'crop',
  CROP_TASK: 'crop_task',
  ORG_TASK: 'org_task',
  REPORT: 'report',
}

export const ENTRY_TYPE_LABELS = {
  [ENTRY_TYPES.CROP]: 'Crop Notes',
  [ENTRY_TYPES.CROP_TASK]: 'Crop Task Notes',
  [ENTRY_TYPES.ORG_TASK]: 'Plot/Farm Task Notes',
  [ENTRY_TYPES.REPORT]: 'Reports',
}

export const ALL_ENTRY_TYPES = Object.values(ENTRY_TYPES)

export const normalizeCropEntry = (crop) => ({
  id: `crop_${crop.id}`,
  type: ENTRY_TYPES.CROP,
  title: crop.name,
  subject: crop.organization?.name ?? '',
  writtenBy: crop.created_by ?? null,
  publishedAt: crop.created_at,
  notes: crop.crop_details?.notes ?? null,
})

export const normalizeTaskEntry = (task) => {
  const isCropTask = !!task.crop_id
  return {
    id: `task_${task.id}`,
    type: isCropTask ? ENTRY_TYPES.CROP_TASK : ENTRY_TYPES.ORG_TASK,
    title: isCropTask
      ? `${task.crop?.name ?? 'Unknown Crop'} — ${task.task_type?.name ?? ''}`
      : `${task.organization?.name ?? ''} — ${task.task_type?.name ?? ''}`,
    subject: isCropTask ? (task.crop?.name ?? '') : (task.organization?.name ?? ''),
    writtenBy: task.created_by ?? null,
    publishedAt: task.updated_at ?? task.created_at,
    notes: task.notes,
  }
}

export const normalizeReportEntry = (report) => ({
  id: `report_${report.id}`,
  type: ENTRY_TYPES.REPORT,
  title: report.report_types?.name ?? 'Report',
  subject: report.organization?.name ?? '',
  writtenBy: report.reported_by ?? null,
  publishedAt: report.created_at,
  notes: report.notes,
})

export const applyFilters = ({ entries, activeTypes, searchQuery, dateFrom, dateTo }) => {
  let result = entries

  if (activeTypes && activeTypes.length < ALL_ENTRY_TYPES.length) {
    result = result.filter(e => activeTypes.includes(e.type))
  }

  if (dateFrom) {
    const from = dayjs(dateFrom).startOf('day')
    result = result.filter(e => dayjs(e.publishedAt).isAfter(from) || dayjs(e.publishedAt).isSame(from))
  }

  if (dateTo) {
    const to = dayjs(dateTo).endOf('day')
    result = result.filter(e => dayjs(e.publishedAt).isBefore(to) || dayjs(e.publishedAt).isSame(to))
  }

  if (searchQuery && searchQuery.trim()) {
    result = matchSorter(result, searchQuery.trim(), {
      keys: ['title', 'subject', 'notes'],
    })
  }

  return result
}

export const formatPublishedDate = (isoString) => {
  if (!isoString) return ''
  const d = dayjs(isoString)
  return d.isValid() ? d.format('MMMM D, YYYY') : ''
}
